/* Timezone — время показываем в ВЫБРАННОЙ зоне, ровно как строятся фильтры по дате */
import { inTz, nowInTz } from "../../helpers/timezone"

/* Translate */
import { t } from "../../translates/translate"


/* LEVELS OF A RECORD — THE COLUMN IS A PLAIN STRING, THE GAME SERVERS DECIDE WHAT TO WRITE THERE */
const LEVELS = {
    error: "error",
    fatal: "error",
    critical: "error",
    warning: "warning",
    warn: "warning",
    info: "info",
    debug: "info",
    notice: "info",
}


/* LEVEL OF A RECORD — AN UNKNOWN TYPE STILL GETS A LOOK OF ITS OWN */
export const getLevel = (type) => {

    /* Fields */
    const value = String(type || "").toLowerCase()

    /* Send Result */
    return LEVELS[value] ? LEVELS[value] : "other"
}


/* DATE WITH THE SECONDS — A LOG IS READ BY THE SECOND, NOT BY THE MINUTE */
export const formatDate = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY HH:mm:ss")
}


/* TIME OF A RECORD */
export const formatTime = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("HH:mm:ss")
}


/* DAY OF A RECORD */
export const formatDay = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY")
}


/* HOW LONG AGO IT HAPPENED
 * The units are abbreviations on purpose — they need no plural agreement in any language,
 * and anything older than two months is shown as a plain date instead. */
export const formatAgo = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Fields */
    const minutes = nowInTz().diff(inTz(value), "minutes")

    /* Check Future — the clock of a game server may run ahead of the panel */
    if (minutes < 1) {
        return t("log.ago.now")
    }

    /* Minutes */
    if (minutes < 60) {
        return `${minutes} ${t("log.ago.minutes")} ${t("log.ago.suffix")}`
    }

    /* Hours */
    if (minutes < 60 * 24) {
        return `${Math.floor(minutes / 60)} ${t("log.ago.hours")} ${t("log.ago.suffix")}`
    }

    /* Days */
    if (minutes < 60 * 24 * 60) {
        return `${Math.floor(minutes / (60 * 24))} ${t("log.ago.days")} ${t("log.ago.suffix")}`
    }

    /* Send Result */
    return formatDay(value)
}


/* PERIOD OF THE LIST — THE OLDEST AND THE NEWEST RECORD OF THE CURRENT FILTER */
export const formatRange = (first, last) => {

    /* Check Values */
    if (!first || !last) {
        return "-"
    }

    /* Fields */
    const from = formatDay(first)
    const to = formatDay(last)

    /* Check One Day */
    if (from === to) {
        return from
    }

    /* Send Result */
    return `${from} — ${to}`
}


/* NAME OF A GAME — PART OF THE SLUGS IS ALREADY DELETED FROM Tables, THEN THE SLUG IS ALL WE HAVE */
export const getName = (item) => {

    /* Check Name */
    if (item.tableName) {
        return item.tableName
    }

    /* Check Slug */
    if (item.table) {
        return item.table
    }

    /* Send Result */
    return t("log.noTable")
}


/* THE MESSAGE OF THE LIST IS CUT BY THE SERVER — THE FULL TEXT COMES WITH THE MODAL */
export const isCut = (item) => {

    /* Check Length */
    if (!item.length || !item.message) {
        return false
    }

    /* Send Result */
    return parseInt(item.length) > String(item.message).length
}
